"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveCourseFilters = exports.loadCourseFilters = void 0;
function storageKey() {
    return "hovo:course-filters:v1:".concat(window.location.pathname).concat(window.location.search);
}
function isFilterValue(value) {
    return typeof value === "string" || (typeof value === "number" && Number.isFinite(value));
}
function isCourseFilters(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
        return false;
    }
    return Object.entries(value).every(function (_a) {
        var field = _a[0], selection = _a[1];
        if (field === "is_online") {
            return typeof selection === "boolean";
        }
        return ["dag", "locatie", "seizoen", "vakgebied", "cursus"].includes(field) &&
            (Array.isArray(selection) ? selection.every(isFilterValue) : isFilterValue(selection));
    });
}
function loadCourseFilters() {
    try {
        var stored = window.sessionStorage.getItem(storageKey());
        if (stored === null) {
            return undefined;
        }
        var selection = JSON.parse(stored);
        if (!isCourseFilters(selection)) {
            throw new Error("Invalid stored course filters");
        }
        return selection;
    }
    catch (error) {
        console.error("Could not restore course filters from session storage.", error);
        return undefined;
    }
}
exports.loadCourseFilters = loadCourseFilters;
function saveCourseFilters(selection) {
    try {
        window.sessionStorage.setItem(storageKey(), JSON.stringify(selection));
    }
    catch (error) {
        console.error("Could not save course filters to session storage.", error);
    }
}
exports.saveCourseFilters = saveCourseFilters;
